export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-en@2x-5fbbd561cf288b4e93655112bf8baec3.png";